<template>
<div class="app has-header">
    <div class="header">
        <menutabs :state="{tabs: tabs}" :tab-selected="tabSelected" @tab-select="UpdateSelectedView"></menutabs>
    </div>
    <component :is="tabSelected.view"/>
           
</div>
</template>

<script>
import storestructure from '../storedatacontext/StoreStructure.vue'
import storeplanningguidelines from '../storedatacontext/StorePlanningGuidelines.vue'
import storeeventoverview from '../storedatacontext/StoreEventOverview'

import storesettings from '../storesettingcontext/StoreSettings.vue'
import allowedcontracts from '../storesettingcontext/AllowedContracts.vue'
import contactpersons from '../storesettingcontext/ContactPersonOverview.vue'
import emailnotifications from '../storesettingcontext/EmailNotificationOverview.vue'
import storeopeninghours from '../storesettingcontext/StoreOpeningHoursOverview.vue'
import externalapiaccess from '../storesettingcontext/ExternalApiAccessOverview.vue'

import userroles from '../rolecontext/Roles.vue'
import collectivecontracts from '../storesettingcontext/CollectiveContracts.vue'
import { mapState, mapGetters } from 'vuex';
export default {
    components: {
        storestructure,
        storeplanningguidelines,
        userroles,
        storeeventoverview,
        storesettings, 
        allowedcontracts,
        collectivecontracts,
        contactpersons,
        emailnotifications,
        storeopeninghours,
        externalapiaccess
    },
    name: 'StoreMain',
    data() {
        return {
            viewMode: 1,
            loading: true,
            loadingText: '',
            tabSelected: null,
        }
    },
    props: {
        view: String,
    },
    created() {
        window.storemain = this;
        let view = this;
        if(this.$router.currentRoute.params.tab){
            let tab = this.tabs.find(t => t.view === view.$router.currentRoute.params.tab);
            if(tab){
                this.tabSelected = tab;
            }
        } else {
            let tab = this.tabs.find(t => t.selected);
            if(tab) this.tabSelected = tab;
            else this.tabSelected = {view: this.view ? this.view : 'storestructure'};
        }
    },
    mounted(){

    },
    computed: {
        ...mapGetters(['storeId','storeSettings', 'isSuperUser', 'userInfo']),
        tabs(){
            let tabs = [
                {label: this.$t('store.structure.title'), view: 'storestructure', selected: true, margin: true},
                {label: this.$t('store.templates.title'), view: 'storeplanningguidelines', margin: true},
                {label: this.$t('store.roles.title'), view: 'userroles', margin: true},
                {label: this.$t('store.events.title'), view: 'storeeventoverview', margin: true},
                {label: this.$t('store.settings.title'), view: 'storesettings', margin: true},
                {label: this.$t('store.openingHours.title'), view: 'storeopeninghours', margin: true},
                {label: this.storeSettings.country == 1 ? this.$t('store.collectiveContracts.title') : this.$t('store.modelContracts'), view: 'allowedcontracts', margin: true},
                {label: this.$t('store.contact.title'), view: 'contactpersons', margin: true},
                {label: this.$t('store.notifications.title'), view: 'emailnotifications', margin: true},
                {label: this.$t('store.api.title'), view: 'externalapiaccess', margin: true},
            ]

            let validSuperUser = ['91bce5c8-6172-43bb-8e6a-721032659d94', ]
            if(this.isSuperUser && validSuperUser.includes(this.userInfo.id)){
                tabs.push({label: 'KV Basis Daten', view: 'collectivecontracts', margin: true, 'onlyAdmin' : true});
            }
            
            if(this.storeSettings && this.storeSettings.simpleMode){
                tabs.splice(1, 1) //removes storeplanningguidelines
            }
            return tabs;
        }
    },
    updated() {},
    destroyed() {},
    methods: {
        UpdateSelectedView(tab){
            this.tabs.forEach(t => t.selected = false);
            tab.selected = true;
            this.tabSelected = tab;
        }
    }
}
</script>
